// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f5-a";
export var fulfillmentFormRail = "_f5-9";
export var headerTitleRow = "_f5-c";
export var orderDetailsWrapper = "_f5-7";
export var orderLinkTrigger = "_f5-2";
export var paymentInformationGrid = "_f5-h";
export var paymentSummaryColumn = "_f5-i";
export var shipmentContainer = "_f5-b";
export var shipmentDetailsMainPane = "_f5-8";
export var shipmentNavigationCard = "_f5-5";
export var shipmentNavigationRail = "_f5-3";
export var shipmentNavigationRailHeader = "_f5-4";
export var shipmentSummaryFact = "_f5-e";
export var shipmentSummaryGrid = "_f5-d";
export var shipmentSummaryMetadataRow = "_f5-f";
export var shipmentSummaryTags = "_f5-g";
export var shipmentWorkspace = "_f5-0";
export var shipmentWorkspaceContent = "_f5-6";
export var shipmentWorkspaceHeader = "_f5-1";